$('.no-js').removeClass('no-js').addClass('js');

// SVG-Unterstützung für IE laden.
svg4everybody();

var template_path = $('html').data('path');

// Menü ein-/ausblenden.
$('.toggle').each(function() {

  var toggle_for = $('#' + $(this).data('for'));

  toggle_for.hide();

  $(this).click(function(e) {
    $(this).toggleClass('active');
    toggle_for.slideToggle({
            duration: 'fast',
            step: function() {
                if ($(this).css('display') == 'flex') {
                    $(this).css('display', 'block');
                }
            },
            complete: function() {
                if ($(this).css('display') == 'flex') {
                    $(this).css('display', 'block');
                }
            }
        })
  });
});

// Slide up on menu link click.
$('#main-menu a').click(function() {
  if ($(window).width()<1024) {
    $('.menu-button').removeClass('active');
    $('#main-menu').slideUp();
  }
})

/**
 * Add hash to url without scrolling
 *
 * @param String $url - it could be hash or url with hash
 *
 * @return void
 */
function addHashToUrl($url) {
  if ('' == $url || undefined == $url) {
    $url = '_'; // it is empty hash because if put empty string here then browser will scroll to top of page
  }
  $hash = $url.replace(/^.*#/, '');
  var $fx, $node = jQuery('#' + $hash);
  if ($node.length) {
    $fx = jQuery('<div></div>')
      .css({
        position: 'absolute',
        visibility: 'hidden',
        top: jQuery(window).scrollTop() + 'px'
      })
      .attr('id', $hash)
      .appendTo(document.body);
    $node.attr('id', '');
  }
  document.location.hash = $hash;
  if ($node.length) {
    $fx.remove();
    $node.attr('id', $hash);
  }
}

// Softscroll
$('.a_link').mouseup(function() {
  this.blur();
})



$(function() {
  $(window).scroll(function() {
    var scroll = $(window).scrollTop();
    //Add sticky class to body when scrolling
    // if (scroll > 220) {
    //   $('html').addClass('sticky');
    //
    // } else {
    //   $('html').removeClass('sticky');
    // }
  });
});
$(document).ready(function() {
  // Check window width
  function checkWidth() {
        var windowsize = $(window).width();
        offSet = (windowsize >= 1280 ) ?  120 : 120-53; // Change Offset for higher header at xxlarge
    }
    // Check on load:
     checkWidth();
     // Check on resize:
     $(window).resize(checkWidth);

     $('a[href^="#"]').on('click', function(e) {
       var href = $(this).attr('href');
       if ($(href).offset()) {
         $('html, body').animate({
           scrollTop: $(href).offset().top - offSet
         }, 'slow');
       }else{
         $('html, body').animate({
           scrollTop: -20
         }, 'slow');
       }

       e.preventDefault();
     });

  // Aktiviert Lightbox für Einzelbild.
  $('.wp-block-image a').featherlight();
  // $('.wp-block-image a').append('<svg role="img" class="symbol" aria-hidden="true" focusable="false"><use xlink:href="' + template_path + '/img/icons.svg#expand"></use></svg>');

  // Aktiviert Lightbox für Galerie.
  $('.blocks-gallery-item a').featherlightGallery({
    previousIcon: '&#9664;',
    /* Code that is used as previous icon */
    nextIcon: '&#9654;',
    /* Code that is used as next icon */
    galleryFadeIn: 100,
    /* fadeIn speed when slide is loaded */
    galleryFadeOut: 300 /* fadeOut speed before slide is loaded */
  });
  // $('.blocks-gallery-item a').append('<svg role="img" class="symbol" aria-hidden="true" focusable="false"><use xlink:href="' + template_path + '/img/icons.svg#expand"></use></svg>');


});
// Google map
$("a.gmap-overlay").click(function(e) {
  e.preventDefault();
  $(this).parent(".google-map").html("<iframe class=\"gmap-iframe\" src=\"" + $(this).attr("href") + "\"></iframe>");
});
